import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';

const LogOut = ({ onDisconnectSocket }) => {
    const navigate = useNavigate();

    useEffect(() => {
        

        localStorage.clear(); //Limpiar y vaciar el localStorage.

        onDisconnectSocket() //Invocar a la función de callback para desconectar el socket.

        //Redireccionar al Login.
        navigate('/', { replace: true });

        //Mostrar en consola Sesión Cerrada.
        console.log('Sesión Cerrada');
    }, []);

    return null
};

export default LogOut;